
export default {//改变state里定义的变量的方法,调用方法是this.$store.commit('方法名','要改变的数据')
    setinfo (stata, obj) {
        stata.unitList = obj
    },
    setmsg (stata, obj) {
        stata.msg = obj
    },
    setError_book (state, arr) {
        state.error_details = arr;
    },
    setLoading (state, boolean) {
        state.loading = boolean;
    },
    setSharData (state, obj) {
        state.sharData = obj;
    },
    setActiveTitle (state, str) {
        state.activeTitle = str;
    },
    setWinter (state, num) {
        state.winterlevel = num;
    },
    setWrongArr (state, arr) {
        state.wrongArr = arr;
    },
    setErrorTabIndex (state, num) {
        state.errorTabIndex = num;
    },
    setTabNum (state, num) {
        state.tabNum = num;
    }
}
